import { complement, isNil, cond, always, T } from 'ramda';

const isNotError = (t) => t instanceof Error ? false : true;

const isNotNil = (t) => complement(isNil)(t);

const whenDefined = (depends, fn) => cond([
    [isNil, always(undefined)],
    [T, (deps) => fn(deps)],
])(depends);

const passAll$1 = (depends) => depends instanceof Array ? depends.every(isNotNil) : isNotNil(depends);
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function whenDefinedAll(depends, fn) {
    return whenDefined(depends, cond([
        [passAll$1, (deps) => fn(deps)],
        [T, always(undefined)],
    ]));
}

const whenNotError = (depends, fn) => cond([
    [isNotError, fn],
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [T, always(depends)],
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
])(depends);

const passAll = (depends) => depends instanceof Array ? depends.every(isNotError) : isNotError(depends);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function whenNotErrorAll(depends, fn) {
    return whenDefined(depends, cond([
        [passAll, (deps) => fn(deps)],
        [
            T,
            always(depends instanceof Array
                ? depends.find((d) => !isNotError(d))
                : depends),
        ],
    ]));
}

export { isNotError, isNotNil, whenDefined, whenDefinedAll, whenNotError, whenNotErrorAll };
